import { Box, Grid, Typography, Button } from "@mui/material";
import { Form, Input, notification } from "antd";
import React, { useState } from "react";
import { AllTypoFontStyles, SettingsStyles } from "../../../Styles/styles";
import { useMediaQuery } from "@mui/material";
import { useChangePasswordMutation } from "../../../Redux/apis/ApiSlice";

export default function ChangePassword() {
  const isXlScreen = useMediaQuery("(min-width: 1440px)");
  const isLgScreen = useMediaQuery("(min-width: 1024px)");
  const isMdScreen = useMediaQuery("(min-width: 768px)");

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [changePassword] = useChangePasswordMutation();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!oldPassword || !newPassword || !confirmPassword) {
      setError("Please fill in all fields!");
      return;
    }
    // Check password length
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters!");
      return;
    }

    // Check if new password and confirm password match
    if (newPassword !== confirmPassword) {
      // notification.error({ description: "New password and confirm password do not match!" })
      setError("Passwords do not match!");
      return;
    }

    try {
      const response = await changePassword({
        oldPassword,
        newPassword,
        confirmPassword,
      }).unwrap();
      setSuccess(response.message);
      notification.success({ message: response.message });
      setError("");
    } catch (err) {
      notification.error({ message: err.data.message });
      setError(err.message);
      setSuccess("");
    }
  };

  return (
    <div>
      <Grid>
        <Grid item md={6} sx={{ textAlign: "left" }}>
          <Form.Item
            name="oldpassword"
            rules={[
              { required: true, message: "Please enter your Old password!" },
            ]}
          >
            <Typography sx={AllTypoFontStyles.CommonTypo2}>
              Old Password
            </Typography>
            <Input.Password
              style={{
                width: isLgScreen
                  ? "50%"
                  : isMdScreen
                  ? "50%"
                  : isXlScreen
                  ? "20%"
                  : "100%",
              }}
              size="large"
              placeholder="Old Password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
            />
          </Form.Item>
        </Grid>
        <Grid item md={6} sx={{ textAlign: "left" }}>
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Please enter your password!" },
              { min: 8, message: "Password must be at least 8 characters!" }, // Minimum length validation
            ]}
          >
            <Typography sx={AllTypoFontStyles.CommonTypo2}>New Password</Typography>
            <Input.Password
              style={{
                width: isLgScreen
                  ? "50%"
                  : isMdScreen
                  ? "50%"
                  : isXlScreen
                  ? "20%"
                  : "100%",
              }}
              size="large"
              placeholder="Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </Form.Item>
        </Grid>
        <Grid item md={6} sx={{ textAlign: "left" }}>
          <Form.Item
            name="confirmPassword"
            rules={[
              {
                required: true,
                message: "Please enter your Confirm password!",
              },
            ]}
          >
            <Typography sx={AllTypoFontStyles.CommonTypo2}>
              Confirm Password
            </Typography>
            <Input.Password
              style={{
                width: isLgScreen
                  ? "50%"
                  : isMdScreen
                  ? "50%"
                  : isXlScreen
                  ? "20%"
                  : "100%",
              }}
              size="large"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </Form.Item>
        </Grid>
        {error && (
          <Grid item xs={12}>
            <Typography color="error">{error}</Typography>
          </Grid>
        )}

        {success && (
          <Grid item xs={12}>
            <Typography color="success">{success}</Typography>
          </Grid>
        )}
        <Box
          sx={{
            display: "flex",
            // mr: 4,
            mb: 3,
            float: "right",
            flexDirection: { md: "row", sm: "column", xs: "column" },
            gap: 2,
          }}
        >
          {/* <Button sx={SettingsStyles.ResetBtnStyles} variant="outlined">
            Reset Changes
          </Button> */}
          <Button
            sx={SettingsStyles.UpdateBtnStyles}
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Update
          </Button>
        </Box>
      </Grid>
    </div>
  );
}
